<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="订单编号">
              <a-input placeholder="请输入" v-model="where.keyword.id" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="用户">
              <a-input placeholder="用户名/姓名/手机号/身份证号" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单状态">
              <a-select v-model="where.keyword.status" placeholder="请选择" allowClear>
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="1">待支付</a-select-option>
                <a-select-option value="5">已完成</a-select-option>
                <a-select-option value="6">已取消</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="用户组">
              <a-select show-search v-model="where.keyword.groupId" :filter-option="filterOption" allowClear
                @change="groupChanged">
                <a-select-option :value="info.id" v-for="(info, index) in grouplist" :key="index">{{ info.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="付款时间">
              <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onPayTimeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="下单时间">
              <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onAddTimeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="单位名称">
              <a-input placeholder="请输入" v-model="where.keyword.company" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="主管部门">
              <a-select show-search v-model="where.keyword.administration" :filter-option="filterOption" allowClear
                @change="administrationChanged">
                <a-select-option :value="info.itemName" v-for="(info, index) in administrationList" :key="index">{{
                  info.itemName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="所在地区">
              <a-cascader :options="areas" placeholder="请选择所在地区" change-on-select @change="onAreachange"
                :default-value="areaList" :fieldNames="{ label: 'name', value: 'name', children: 'children' }" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="支付类型">
              <a-select show-search v-model="where.keyword.paymentMethod" :filter-option="filterOption" allowClear
                @change="paymentMethodChanged">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="线下支付">线下支付</a-select-option>
                <a-select-option value="wechatjs">微信支付</a-select-option>
                <a-select-option value="wallet">余额支付</a-select-option>
                <a-select-option value="wechatqr">微信扫码</a-select-option>
                <a-select-option value="alipayqr">支付宝扫码</a-select-option>
                <a-select-option value="chinaums">银联商务</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

        </a-row>
        <a-row>
          <a-col :span="8" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList" v-btnlimit="'订单管理-搜索'">搜索</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button>
          </a-col>
          <a-col :span="16" :style="{ textAlign: 'right' }">
            <div class="totalbox" style="margin-top: 10px;">
              <span>订单数：{{ list.pagination.total }}条</span>
              <span style="margin-left: 20px;">已支付金额：{{ sumPrice }}元</span>
              <span style="margin-left: 20px;">待支付金额：{{ sumWaitPrice }}元</span>
              <span style="margin-left: 20px;">退款金额：{{ sumRefund }}元</span>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <!--      <pxkeji-btn name="批量导出" v-if="selectRows.length>0" class="pxkeji_basic_btn" />-->
      <!--      <pxkeji-btn name="批量启用" v-if="selectRows.length>0" class="pxkeji_basic_btn" />-->
      <!--      <pxkeji-btn name="批量禁用" v-if="selectRows.length>0" class="pxkeji_basic_btn" />-->

      <a-table :columns="list.columns" rowKey="id" :pagination="list.pagination" @change="onChange"
        :dataSource="list.datas" :loading="isloading" :locale="{ emptyText: '暂无数据' }">
        <span slot="countAccount" slot-scope="info">
          <span v-if="!info.countAccount">暂无</span>
          <a-tooltip placement="top" arrowPointAtCenter>
            <template slot="title">
              <span>点击查看详情</span>
            </template>
            <a-badge :count="info.countAccount" class="pointer" :overflowCount="9999999" @click="agentChildBox(info.id)"
              :numberStyle="{ backgroundColor: '#1890ff' }" />
          </a-tooltip>
        </span>
        <span slot="paymentMethod" slot-scope="paymentMethod">
          <a-tag v-if="paymentMethod == 'wechatapp'" color="green">微信APP</a-tag>
          <a-tag v-else-if="paymentMethod == 'wechatqr'" color="green">微信扫码</a-tag>
          <a-tag v-else-if="paymentMethod == 'alipayapp'" color="green">支付宝App</a-tag>
          <a-tag v-else-if="paymentMethod == 'alipayqr'" color="green">支付宝扫码</a-tag>
          <a-tag v-else-if="paymentMethod == '线下支付'" color="green">线下支付</a-tag>
          <a-tag v-else-if="paymentMethod == 'wallet'" color="green">余额支付</a-tag>
          <a-tag v-else-if="paymentMethod == 'wechatjs'" color="green">微信支付</a-tag>
        </span>
        <span slot="orderStatus" slot-scope="orderStatus">
          <a-tag v-if="orderStatus == 1" color="orange">待支付</a-tag>
          <a-tag v-else-if="orderStatus == 2" color="orange">待发货</a-tag>
          <a-tag v-else-if="orderStatus == 3" color="blue">待收货</a-tag>
          <a-tag v-else-if="orderStatus == 4" color="blue">待评价</a-tag>
          <a-tag v-else-if="orderStatus == 5" color="green">已完成</a-tag>
          <a-tag v-else-if="orderStatus == 6" color="red">已取消</a-tag>
          <a-tag v-else color="red">已退款</a-tag>
        </span>
        <span slot="action" slot-scope="info">
          <pxkeji-btn name="查看" size="small" @click="showInfo(info)" type="primary" v-btnlimit="'订单管理-查看'" />
          <pxkeji-btn
            v-if="(info.paymentMethod == 'wechatapp' || info.paymentMethod == 'wechatqr' || info.paymentMethod == 'alipayapp' || info.paymentMethod == 'alipayqr' || info.paymentMethod == 'wechatjs') && info.status == 5"
            name="退款" size="small" @click="showCourse(info.id)" type="dashed" v-btnlimit="'订单管理-退款'" />
        </span>
      </a-table>
    </div>

    <a-drawer title="订单详情" :width="750" placement="right" @close="hideInfo" destroyOnClose :visible="addedit.visible">
      <Info :infos="addedit.info" @callbackMethod="save" />
    </a-drawer>
    <a-modal v-model="chooseCourseInfoShow" :footer="false" destroyOnClose width="70%" :maskClosable="false"
      class="ui-modal">
      <InfoList @callbackMethod="GetList" :id="orderId" />
    </a-modal>

  </div>
</template>
<script>
import Info from "./orderInfo.vue";
import InfoList from "./refoundCourse.vue"; //已购课程

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "订单编号"
  },
  {
    dataIndex: "userName",
    key: "userName",
    align: "center",
    title: "会员"
  },
/*  {
    dataIndex: "phone",
    key: "phone",
    align: "center",
    title: "手机号"
  },*/
  {
    dataIndex: "idCard",
    key: "idCard",
    align: "center",
    title: "身份证号"
  },
  {
    dataIndex: "payprice",
    key: "payprice",
    align: "center",
    title: "支付金额"
  },
  {
    dataIndex: "totalprice",
    key: "totalprice",
    align: "center",
    title: "订单总金额"
  },
  {
    dataIndex: "addtime",
    key: "addtime",
    align: "center",
    title: "下单时间"
  },
  {
    dataIndex: "paymentMethod",
    key: "paymentMethod",
    align: "center",
    title: "支付方式",
    scopedSlots: { customRender: "paymentMethod" }
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "orderStatus" }
  },

  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

var that;
export default {
  name: "orderList",
  data() {
    return {
      chooseCourseInfoShow: false,
      // 2021 09 28 start
      areas: [],
      areaList: [],
      grouplist: [],
      administrationList: [], //2021 11 01
      //2021 09 28 end
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      //统计已支付金额
      sumPrice: 0,
      //统计待支付金额
      sumWaitPrice: 0,
      //统计退款金额
      sumRefund: 0,

      where: {
        //查询条件
        keyword: {
          //搜索条件
          id: "",
          name: "",
          status: "",
          telephone: "",
          idCard: "",
          // 2021 09 28 start
          groupId: "",
          province: '',
          city: '',
          area: '',
          // 2021 11 01 start
          startPayTime: "",
          endPayTime: "",
          startAddTime: "",
          endAddTime: "",
          company: "",
          administration: "",
          paymentMethod: "",
          // 2021 11 01 end
          // 2021 09 28 end
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      infoId: 0, //添加时为0，修改是为编号
      infoData: {},
      orderId: "",
      agentChildBoxShow: false,
      visible: false, //弹框
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
    };
  },
  components: {
    Info: Info,
    InfoList: InfoList
  },
  mounted: function () {
    this.$nextTick(function () {
      that = this;
      this.GetList();
      this.getarea(); //2021 09 28
      this.getgrouplist();//2021 09 28
      this.getDictionaryItem(); //2021 11 01
    });
  },
  watch: {
    selectRows: function () {
      //console.log("watch", val);
    }
  },
  methods: {
    // 2021 11 01 start
    //获取数据字典
    getDictionaryItem() {
      this.$api.dictionaryItem.tree(23).then((res) => {
        if (res.errorCode == this.$msg.responseCode.success) {
          this.administrationList = res.data;
        } else {
          this.error(res.errorMsg);
        }
      });

    },
    administrationChanged(v) {
      this.where.keyword.administration = v;
    },
    onPayTimeChange(date, dateString) {
      this.where.keyword.startPayTime = dateString[0];
      this.where.keyword.endPayTime = dateString[1];
    },
    onAddTimeChange(date, dateString) {
      this.where.keyword.startAddTime = dateString[0];
      this.where.keyword.endAddTime = dateString[1];
    },
    paymentMethodChanged(v) {
      this.where.keyword.paymentMethod = v;
    },
    // 2021 11 01 end
    // 2021 09 28 start
    onAreachange(v) {
      if (v[0]) {
        this.where.keyword.province = v[0];
      } else {
        this.where.keyword.province = '';
      }
      if (v[1]) {
        this.where.keyword.city = v[1];
      } else {
        this.where.keyword.city = '';
      }
      if (v[2]) {
        this.where.keyword.area = v[2];
      } else {
        this.where.keyword.area = '';
      }
    },
    getarea() {
      this.areas = this.$api.city.city;
    },
    groupChanged(v) {
      this.where.keyword.groupId = v; //2021 09 28
    },
    getgrouplist() {
      this.isloading = true;
      this.$api.usergroup
        .getAll()
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.grouplist = res.data;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
    // 2021 10 22 start
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 2021 10 22 end
    // 2021 09 28 end
    toggle() {
      this.expand = !this.expand;
    },
    showCourse(id) {
      this.chooseCourseInfoShow = true;
      this.orderId = id;
    },
    GetList() {
      //获取用户列表



      this.isloading = true;
      this.clearRows();
      this.$api.order
        .pageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.id,
          (this.where.keyword.name == "" ? null : this.where.keyword.name),

          this.where.keyword.status,
          1,
          this.where.keyword.province,
          this.where.keyword.city,
          this.where.keyword.area,
          this.where.keyword.groupId,
          this.where.keyword.company,
          this.where.keyword.startPayTime,
          this.where.keyword.endPayTime,
          this.where.keyword.startAddTime,
          this.where.keyword.endAddTime,
          this.where.keyword.administration,
          this.where.keyword.paymentMethod,
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
            this.sumPrice = res.data.sumPrice;
            this.sumWaitPrice = res.data.sumWaitPrice;
            this.sumRefund = res.data.sumRefund;
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    refresh() {
      this.GetList();
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    hideInfo() {
      //this.visible = false;
      this.addedit.visible = false;
    },
    showInfo(info) {
      //打开弹出框
      this.addedit.visible = true;
      this.addedit.title = info.id ? "编辑" : "新增";
      this.addedit.info = info;
    },
    save() {
      // this.visible = false;
      // this.agentChildBoxShow = false;
      this.addedit.visible = false;
      this.GetList();
    }

  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

